import { useUserContext } from 'common/contexts/UserContext';
import * as React from 'react';

interface Props {
  className?: string;
}

export const Hi: React.FC<Props> = (props) => {
  const { user } = useUserContext();
  const name = user?.first_name;

  if (!name) {
    return null;
  }

  return <p className={`font-medium ${props.className}`}>Hi {name}!</p>;
};
